export default "__VITE_ASSET__hs7HqEIt__"